import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/system/dict-data',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/system/dict-data/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/system/dict-data',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/system/dict-data',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/system/dict-data/${id}`);
    },
}
